import styled from 'styled-components'

import Theme from 'styles/theme'

const DEFAULT_COLOR = Theme['-ds-core-400'].value
const DEFAULT_OPACITY = 0.2
const DEFAULT_Z_INDEX = 10

type Options = {
  color: string
  opacity?: number
  zIndex?: number
}

const UniformOverlay = styled.div<Options>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ color = DEFAULT_COLOR }) => color};

  z-index: ${({ zIndex = DEFAULT_Z_INDEX }) => zIndex};

  opacity: ${({ opacity = DEFAULT_OPACITY }) => opacity};
`

export default UniformOverlay
